import { Header } from '../../../components/feature/Header';
import { Footer } from '../../../components/feature/Footer';
import { SmallApartmentBuildingsHero } from './components/SmallApartmentBuildingsHero';
import { WhatAreSmallApartmentBuildings } from './components/WhatAreSmallApartmentBuildings';
import { WhyWeSpecialize } from './components/WhyWeSpecialize';
import { PropertyTypesWeBuy } from './components/PropertyTypesWeBuy';
import { SellerBenefits } from './components/SellerBenefits';
import { OurPurchaseProcess } from './components/OurPurchaseProcess';
import { CommonChallenges } from './components/CommonChallenges';
import { MarketInsights } from './components/MarketInsights';
import { CaseStudies } from './components/CaseStudies';
import { SmallApartmentBuildingsFAQ } from './components/SmallApartmentBuildingsFAQ';
import { GetOfferSection } from './components/GetOfferSection';
import { FinalCTA } from './components/FinalCTA';

export default function SmallApartmentBuildingsPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <SmallApartmentBuildingsHero />
        <WhatAreSmallApartmentBuildings />
        <WhyWeSpecialize />
        <PropertyTypesWeBuy />
        <SellerBenefits />
        <OurPurchaseProcess />
        <CommonChallenges />
        <MarketInsights />
        <CaseStudies />
        <SmallApartmentBuildingsFAQ />
        <GetOfferSection />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}